export default __webpack_public_path__ + "static/media/6.42d601f0.png";